'use client';

import React from 'react';

import { Button } from '@/components/ui/button';
import useShare from '@/hooks/useShare';
import CopyIcon from '@/svgs/copy.svg';
import stripHtml from '@/utils/stripHtml';

type Props = {
  title: string;
  content: string;
  onShare?: () => void;
};

const ShareButton: React.FC<Props> = ({ content, title, onShare }) => {
  const handleShare = useShare({ copyOnly: true });

  return (
    <Button
      variant="secondary"
      size="sm"
      className="p-1.5 text-xs font-normal"
      onClick={() => {
        void handleShare({ url: stripHtml(content) });
        if (onShare) {
          onShare();
        }
      }}
    >
      {title}
      <div className="flex items-center justify-center">
        <CopyIcon className="size-[22px]" />
      </div>
    </Button>
  );
};

export default ShareButton;
